import { DocumentCreationItemContainer } from '@/features/documents/DocumentCreationModal/DocumentCreationItem/DocumentCreationItemContainer'
import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { JobProgressionUploadModal } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionUploadModal'

export interface JobProgressionExtensionDocumentCreationModalContainerProps {
  vm: JobProgressionViewModel
}

export const JobProgressionExtensionDocumentCreationModalContainer = observer(
  function JobProgressionExtensionDocumentCreationModalContainer({
    vm,
  }: JobProgressionExtensionDocumentCreationModalContainerProps) {
    const documentCreationVm = vm.jobProgressionDocumentCreationVm!
    const rejection = vm.isExtensionRejected ? ' rejection ' : ' '

    return (
      <JobProgressionUploadModal
        showing={documentCreationVm.modal.showing}
        dragging={documentCreationVm.dragging}
        title={<>Upload extension{rejection}confirmation</>}
        description={
          <>
            Please mark the document as type 'Extension
            {vm.isExtensionRejected ? ' Rejection ' : ' '}
            Confirmation' to make it easier for the client to find.
          </>
        }
        isUploadDisabled={vm.isUploadDisabled}
        isUploadPending={
          vm.answerExtensionConfirmed.pending ||
          vm.uploadExtensionRejectedDocument.pending
        }
        onRequestClose={documentCreationVm.modal.close}
        onAddFiles={documentCreationVm.addFiles}
        onDragEnter={documentCreationVm.setDragging}
        onDragLeave={documentCreationVm.stopDragging}
        onSkip={
          vm.isSkipUploadDisabled
            ? undefined
            : () =>
                vm.isExtensionRejectedOrWaitingOnClient
                  ? vm.uploadExtensionRejectedDocument(true)
                  : vm.answerExtensionConfirmed(true)
        }
        onUpload={() =>
          vm.isExtensionRejectedOrWaitingOnClient
            ? vm.uploadExtensionRejectedDocument(false)
            : vm.answerExtensionConfirmed(false)
        }
        fileInputTestId="upload-extension-confirmation-documents-file-input"
        uploadButtonTestId="upload-extension-confirmation-confirm-button"
      >
        {documentCreationVm.documentCreationItemVms.map(
          (docCreationItemVm, index) => (
            <div key={index}>
              <DocumentCreationItemContainer
                index={index}
                vm={docCreationItemVm}
                onRemove={documentCreationVm.removeFile}
              />
            </div>
          ),
        )}
      </JobProgressionUploadModal>
    )
  },
)
